import PackageJson from '../../package.json';

const initDatadogRUM = async () => {
  try {
    const res = await fetch('/datadog/customer-mobile-page.json', { cache: 'no-store' });
    if (!res.ok) return;
    const rumConfig = await res.json();

    if (!rumConfig || !rumConfig.applicationId || !rumConfig.clientToken) return;

    (function (h, o, u, n, d) {
      h = h[d] = h[d] || {
        q: [],
        onReady: function (c) {
          h.q.push(c);
        },
      };
      const scriptElem = o.createElement(u);
      scriptElem.async = 1;
      scriptElem.src = n;
      scriptElem.crossOrigin = 'anonymous';
      const firstScript = o.getElementsByTagName(u)[0];
      firstScript.parentNode.insertBefore(scriptElem, firstScript);
    })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js', 'DD_RUM');

    window.DD_RUM.onReady(function () {
      window.DD_RUM.init({
        version: PackageJson.version,
        ...rumConfig,
      });
    });
  } catch (err) {
    return;
  }
};

export default initDatadogRUM;
